import { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";

import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const ResultsPage = () => {
  const { getCategoriesResult } = useContext(AdminContext);
  const [categories, setCategories] = useState(null);

  useEffect(() => {
    document.title = "Результаты по категориям";
    getCategoriesResult().then((res) => {
      setCategories(res.data);
    });
  }, []); 

  return (
    <div className="container">
      <ButtonBack shortBtn userUrl="/admin"/>

      {!categories ? (
        <div style={{ position: "relative", minHeight: 120 }}>
          <CoveredBackground>
            <Loader />
          </CoveredBackground>
        </div>
      ) : (
        <>
          <div className="admin__all__results">
            <div className="admin__all__results__items">
              {categories.map((category) => (
                <Link
                  key={category.id}
                  to={`/admin/results/${category.id}`}
                  className="admin__all__results__item"
                >
                  {category.category}
                </Link>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ResultsPage;
